import { createProvideInject } from '@collector/shared-ui'
import { IncidentId } from '@collector/sportsapi-client-legacy'

export const [provideBetIncidents, injectBetIncidents] =
  createProvideInject<Set<IncidentId>>('betIncidents')
